// extracted by mini-css-extract-plugin
export default {"header":"styles_header__wbXwt","actions":"styles_actions__MPSuS","title":"styles_title__zQbxi","iconButton":"styles_iconButton__XKQC9","icon":"styles_icon__v5tiV"};